/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortedHeader } from "components/Datatable/components/SortedHeader";
import { useFilterActions } from "../../ducks/filter/hooks/actions";

export default function SortedCell({
  ...props
}: {
  title: string;
  column: any;
  orderName?: string;
}) {
  const { updateFilter } = useFilterActions();

  const handleOrderChange = (value: { [key: string | number]: string }) => {
    updateFilter({ key: "order", value });
  };

  return <SortedHeader {...props} setOrder={handleOrderChange} />;
}
